import React from "react"
import UIkit from 'uikit';
import 'uikit/dist/css/uikit.css';
import "../scss/components/faq-component.scss" 
import CustomMarkdown from "../utils/customMarkdown"

const FAQComponent = ({faqList, sectionStyle="white"}) => { 
    const componentBgClass = sectionStyle =="white" ? "white-section" : "dark-section";
    if(faqList != null){
        return(
            <div className={componentBgClass + " faq-component padding-top padding-bottom lateral-padding"}>
                <ul data-uk-accordion="multiple: true">
                    {faqList.map((item, index) => {           
                        return(
                            <li key={index} className="faq-row">   
           
                                <a className="uk-accordion-title faq-toggle" href="#">
                                    {item.Question}    
                                </a>
                                <div className="uk-accordion-content faq-answer">
                                    <CustomMarkdown key={index} children={item.QuestionResponse} />
                                </div>
                                
                            </li>
                        )
                    })}
                </ul>
    
            </div>
        )
    }else{
        return('')
    }

}
export default FAQComponent